const switchers = document.querySelectorAll('select.langSwitcher')
if (switchers) {
  switchers.forEach((switcher) =>
    switcher.addEventListener('change', (e) => {
      window.location.href = e.currentTarget.value
    }),
  )
}
